import { render } from "./SideNavBar.vue?vue&type=template&id=29632331&scoped=true"
import script from "./SideNavBar.vue?vue&type=script&lang=js"
export * from "./SideNavBar.vue?vue&type=script&lang=js"

import "./SideNavBar.vue?vue&type=style&index=0&id=29632331&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29632331"]])

export default __exports__